import { Pipe, PipeTransform } from '@angular/core';

import { ESalesOrderStatusHuman } from '../../sales-order/interfaces';

@Pipe({
  name: 'orderItemStatusLabel',
})
export class OrderItemStatusLabelPipe implements PipeTransform {
  transform(label :string) :string {
    const status :ESalesOrderStatusHuman =
      label.toUpperCase() as ESalesOrderStatusHuman;

    return status in ESalesOrderStatusHuman ? ESalesOrderStatusHuman[status] : '';
  }
}
